import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Artisan, ArtisanTrade, Featured, Geolocalization, ParameterDetail, Profile, PublicProfile } from '../../pages/private/profile/shared/model';
import { map, Observable, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProfileService extends SharedService {
    // Mapeo de ecosistemas a rutas backend
    private ecosystemRouteMap: { [key: string]: string } = {
        artistas: 'artist',
        collective: 'collective',
        empresas: 'business',
        espacios: 'espacio',
        // agregar más
    };

    getEcosystemRoute(ecosystem: string): string {
        return this.ecosystemRouteMap[ecosystem] || 'artist';
    }

    public infoUser: Profile;

    public get vc_uuid_user(): string {
        return this.infoUser?.vc_uuid_user || '';
    }
    public get areas(): Array<string> {
        return this.infoUser?.area?.map((x) => x.i_fk_id_area.toString()) || [];
    }
    public get subAreas(): Array<string> {
        return this.infoUser?.sub_area?.map((x) => x.i_fk_id_sub_area.toString()) || [];
    }
    public get subAreasName(): Array<string> {
        return this.infoUser?.sub_area?.map((x) => x.subarea_name) || [];
    }
    public get areasName(): Array<string> {
        return this.infoUser?.area?.map((x) => x.area_name) || [];
    }
    public get subcampoName(): Array<string> {
        return this.infoUser?.subcampo?.map((x) => x.subcampo_name) || [];
    }
    public get roles(): string {
        return this.infoUser?.roles?.map((x) => x.i_fk_id_rol).join(', ') || '';
    }
    public get services(): Array<ParameterDetail> {
        return this.infoUser?.services.map((x) => x.parameter_detail) || [];
    }

    public get b_ocultarcontacto(): boolean {
        return this.infoUser?.b_ocultarcontacto || false;
    }
    public get vc_phone(): string {
        return this.infoUser?.vc_phone || '';
    }
    public get vc_email(): string {
        return this.infoUser?.vc_email || '';
    }
    public get vc_country(): string {
        return this.infoUser?.country || '';
    }
    public get vc_web(): string {
        return this.infoUser?.vc_web || this.infoUser?.vc_link_paging_offical || '';
    }
    public get b_ocultarredes(): boolean {
        return this.infoUser?.b_ocultarredes || false;
    }
    public get facebook(): string {
        return this.infoUser?.social_network?.facebook || this.infoUser?.social_network?.vc_facebook || '';
    }
    public get instagram(): string {
        return this.infoUser?.social_network?.instagram || this.infoUser?.social_network?.vc_instagram || '';
    }
    public get twitter(): string {
        return this.infoUser?.social_network?.twitter || this.infoUser?.social_network?.vc_twitter || '';
    }
    public get tiktok(): string {
        return this.infoUser?.social_network?.tiktok || this.infoUser?.social_network?.vc_tiktok || '';
    }
    public get linkedin(): string {
        return this.infoUser?.social_network?.linkedin || this.infoUser?.social_network?.vc_linkedin || '';
    }
    public get youtube(): string {
        return this.infoUser?.social_network?.youtube || this.infoUser?.social_network?.vc_youtube || '';
    }
    public get vc_portfolio(): string {
        return this.infoUser?.vc_portfolio || '';
    }
    public get vc_photo_profile(): string {
        return this.infoUser?.vc_photo_profile || '';
    }
    public get total_followers(): number {
        return this.infoUser?.total_followers || 0;
    }
    public get total_following(): number {
        return this.infoUser?.total_following || 0;
    }
    public get currentRate(): number {
        return this.infoUser?.starirs || 0;
    }
    public get tx_biography(): string {
        return this.infoUser?.tx_biography || '';
    }

    public set tx_biography(biography: string) {
        this.infoUser.tx_biography = biography;
    }

    public get tx_characterization(): string {
        return this.infoUser?.characterization || '';
    }

    public get tx_trajectory(): string {
        return this.infoUser?.tx_trajectory || '';
    }

    public get proyectos_trayectoria(): string {
        return this.infoUser?.tx_proyectos_destacados || '';
    }

    public get tiempoExperiencia(): number {
        return this.infoUser?.experience_value || 0;
    }

    public get tiempoExperienciaUnidad(): string {
        return this.infoUser?.experience_unit || '';
    }

    public set tx_trajectory(value: string) {
        if (this.infoUser) {
            this.infoUser.tx_trajectory = value;
        }
    }

    public set proyectos_trayectoria(value: string) {
        if (this.infoUser) {
            this.infoUser.tx_proyectos_destacados = value;
        }
    }

    public set tiempoExperiencia(value: number) {
        if (this.infoUser) {
            this.infoUser.experience_value = value;
        }
    }

    public set tiempoExperienciaUnidad(value: any) {
        if (this.infoUser) {
            this.infoUser.experience_unit = value;
        }
    }

    public get vc_username(): string {
        return this.infoUser?.vc_username || '';
    }
    public get vc_youtube(): string {
        return this.infoUser?.featured?.vc_youtube || '';
    }

    public get vc_vimeo(): string {
        return this.infoUser?.featured?.vc_vimeo || '';
    }

    public get vc_behance(): string {
        return this.infoUser?.featured?.vc_behance || '';
    }

    public get vc_pinterest(): string {
        return this.infoUser?.featured?.vc_pinterest || '';
    }

    public get vc_spotify(): string {
        return this.infoUser?.featured?.vc_spotify || '';
    }

    public get vc_speaker(): string {
        return this.infoUser?.featured?.vc_speaker || '';
    }

    public get vc_soundcloud(): string {
        return this.infoUser?.featured?.vc_soundcloud || '';
    }

    // Getter de formato de URLs embebidas
    public get vc_youtube_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_youtube || '');
    }

    public get vc_vimeo_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_vimeo || '');
    }

    public get vc_behance_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_behance || '');
    }

    public get vc_pinterest_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_pinterest || '');
    }

    public get vc_spotify_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_spotify || '');
    }

    public get vc_speaker_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_speaker || '');
    }

    public get vc_soundcloud_embed(): string {
        return this.getVideoIframe(this.infoUser?.featured?.vc_soundcloud || '');
    }

    public get geolocalization(): Geolocalization {
        return this.infoUser?.geolocalization;
    }
    public set featured(featured: Featured) {
        this.infoUser.featured = featured;
    }

    public get interesesSeleccionados(): string[] {
        return this.infoUser?.intereses_participacion?.split(',') || [];
    }

    public get participacion(): string[] {
        return this.infoUser?.colectivo_perteneciente?.split(',') || [];
    }

    public get artisan(): Artisan {
        return this.infoUser?.artisan;
    }

    public get completeName(): string {
        return `${this.infoUser?.vc_name} ${this.infoUser?.vc_last_name}`.trim();
    }

    //Colectivo datos
    public get vc_name_colective(): string {
        return this.infoUser?.vc_name_collective;
    }

    public get tx_mision_vision(): string {
        return this.infoUser?.mision_vision;
    }

    public get collective_type(): string {
        return this.infoUser?.collective_type;
    }

    public get miembros_activos(): string {
        return this.infoUser?.miembros_activos || '';
    }

    public get creation_date(): string {
        return this.infoUser?.creation_date || '';
    }

    public get incluye_discapacidad(): boolean {
        return this.infoUser?.incluye_discapacidad || false;
    }

    public get tipo_discapacidad(): string {
        return this.infoUser?.tipo_discapacidad || '';
    }

    public get oferta_discapacidad(): string {
        return this.infoUser?.oferta_discapacidad || '';
    }

    public get politicas_inclusion(): string {
        return this.infoUser?.politicas_inclusion || '';
    }

    public get formato_actividades(): string {
        return this.infoUser?.formato_actividades || '';
    }

    public get numero_integrantes(): number {
        return this.infoUser?.numero_integrantes || 0;
    }

    public get espacios_propios(): boolean {
        return this.infoUser?.espacios_propios || false;
    }

    public get detalle_espacios(): string {
        return this.infoUser?.detalle_espacios || '';
    }

    public get grupo_poblacional(): string {
        return this.infoUser?.grupo_poblacional || '';
    }

    public get proyectos_desarrollados(): string {
        return this.infoUser?.proyectos_desarrollados || '';
    }

    public get aliados(): string {
        return this.infoUser?.aliados || '';
    }

    public get territorio_accion(): string {
        return this.infoUser?.territory?.territorio_id || '';
    }

    public get detalle_localidad(): string {
        return this.infoUser?.territory?.detalle || '';
    }

    public get mecanismos_participacion(): string {
        return this.infoUser?.mecanismos_participacion || '';
    }

    public get recursos_publicos(): boolean {
        return this.infoUser?.recursos_cultura || false;
    }

    public get tipo_apoyo_publico(): string {
        return this.infoUser?.tipo_apoyo;
    }

    public get otro_tipo_apoyo(): string {
        return this.infoUser?.otro_tipo_apoyo || '';
    }

    public get instrumentos_gestion(): string {
        return this.infoUser?.insturmentos_apoyo || '';
    }

    public get estrategias_accesibilidad(): string {
        return this.infoUser?.estrategias_accesibilidad ?? this.infoUser?.accesibilidad_inclusion?.estrategias_accesibilidad ?? '';
    }

    public get ajustes_apoyos(): string[] {
        return this.infoUser?.ajustes_apoyos?.split(',') ?? this.infoUser?.accesibilidad_inclusion?.ajustes_apoyos.split(',') ?? [];
    }

    public get interes_fortalecer(): boolean {
        return this.infoUser?.interes_fortalecer ?? this.infoUser?.accesibilidad_inclusion?.interes_fortalecer ?? false;
    }

    public get educacion_inclusiva(): string {
        return this.infoUser?.accesibilidad_inclusion?.educacion_inclusiva || '';
    }

    public get programas_discapacidad(): string {
        return this.infoUser?.accesibilidad_inclusion?.programas_discapacidad || '';
    }

    public get funcion_cultural(): string {
        return this.infoUser?.public_profile?.funcion_cultural || '';
    }

    public get programas_culturales(): string {
        return this.infoUser?.public_profile?.programas_culturales || '';
    }

    public get territorios_incidencia(): string[] {
        return this.infoUser?.public_profile?.territorios_incidencia?.split(',') || [];
    }

    public get poblaciones_trabajo(): string[] {
        return this.infoUser?.public_profile?.poblaciones_trabajo?.split(',') || [];
    }

    public get otro_poblacion(): string | null {
        return this.infoUser?.public_profile?.otro_poblacion || null;
    }

    public get articulaciones_redes(): string {
        return this.infoUser?.public_profile?.articulaciones_redes || '';
    }

    //Data Educativo

    public get tipo_institucion(): string {
        return this.infoUser?.identidad_institucional?.tipo_institucion || '';
    }

    public get naturaleza(): string {
        return this.infoUser?.identidad_institucional?.naturaleza || '';
    }

    public get nivel_educativo(): string {
        return this.infoUser?.identidad_institucional?.nivel_educativo || '';
    }

    public get nivel_otro(): string {
        return this.infoUser?.identidad_institucional?.otro_nivel_educativo || '';
    }

    public get anio_fundacion(): number {
        return this.infoUser?.identidad_institucional?.anio_fundacion || 0;
    }

    public get acreditaciones(): string {
        return this.infoUser?.identidad_institucional?.acreditaciones || '';
    }

    public get oferta_formativa_cultural(): boolean {
        return this.infoUser?.identidad_institucional?.oferta_formativa_cultural || false;
    }

    public get programas(): string[] {
        return this.infoUser?.identidad_institucional?.programas_oferta?.split(',') || [];
    }

    public get modalidad(): string {
        return this.infoUser?.identidad_institucional?.modalidad || '';
    }

    public get duracion_valor(): number {
        return this.infoUser?.identidad_institucional?.duracion_valor || 0;
    }

    public get duracion_unidad(): string {
        return this.infoUser?.identidad_institucional?.duracion_unidad || '';
    }

    public get certificacion(): boolean {
        return this.infoUser?.identidad_institucional?.certificacion || false;
    }

    // GETTERS
    public get grupos_investigacion(): string {
        return this.infoUser?.investigacion_academica?.grupos_investigacion || '';
    }

    public get lineas_investigacion(): string {
        return this.infoUser?.investigacion_academica?.lineas_investigacion_cultural || '';
    }

    public get proyectos_investigacion(): string {
        return this.infoUser?.investigacion_academica?.proyectos_investigacion_vigentes || '';
    }

    public get publicaciones(): string {
        return this.infoUser?.investigacion_academica?.publicaciones || '';
    }

    public get revistas(): string {
        return this.infoUser?.investigacion_academica?.revistas || '';
    }

    public get produccion_academica(): string {
        return this.infoUser?.investigacion_academica?.produccion_academica_descargable || '';
    }

    //SETTERS
    public set grupos_investigacion(value: string) {
        if (this.infoUser) this.infoUser.investigacion_academica.grupos_investigacion = value;
    }

    public set lineas_investigacion(value: string) {
        if (this.infoUser) this.infoUser.investigacion_academica.lineas_investigacion_cultural = value;
    }

    public set proyectos_investigacion(value: string) {
        if (this.infoUser) this.infoUser.investigacion_academica.proyectos_investigacion_vigentes = value;
    }

    public set publicaciones(value: string) {
        if (this.infoUser) this.infoUser.investigacion_academica.publicaciones = value;
    }

    public set revistas(value: string) {
        if (this.infoUser) this.infoUser.investigacion_academica.revistas = value;
    }

    public set produccion_academica(value: string) {
        if (this.infoUser) this.infoUser.investigacion_academica.produccion_academica_descargable = value;
    }
    public set tipo_institucion(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.tipo_institucion = value;
    }

    public set naturaleza(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.naturaleza = value;
    }

    public set nivel_educativo(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.nivel_educativo = value;
    }

    public set otro_nivel_educativo(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.otro_nivel_educativo = value;
    }

    public set anio_fundacion(value: number) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.anio_fundacion = value;
    }

    public set acreditaciones(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.acreditaciones = value;
    }

    public set oferta_formativa(value: boolean) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.oferta_formativa_cultural = value;
    }

    public set programas(value: string[]) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.programas_oferta = value.join(',');
    }

    public set modalidad(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.modalidad = value;
    }

    public set duracion_valor(value: number) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.duracion_valor = value;
    }

    public set duracion_unidad(value: string) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.duracion_unidad = value;
    }

    public set certificacion(value: boolean) {
        if (this.infoUser?.identidad_institucional) this.infoUser.identidad_institucional.certificacion = value;
    }

    public set funcion_cultural(value: string) {
        if (this.infoUser?.public_profile) {
            this.infoUser.public_profile.funcion_cultural = value;
        }
    }

    public set programas_culturales(value: string) {
        if (this.infoUser?.public_profile) {
            this.infoUser.public_profile.programas_culturales = value;
        }
    }

    public set territorios_incidencia(value: string[]) {
        if (this.infoUser?.public_profile) {
            this.infoUser.public_profile.territorios_incidencia = value.join(',');
        }
    }

    public set poblaciones_trabajo(value: string[]) {
        if (this.infoUser?.public_profile) {
            this.infoUser.public_profile.poblaciones_trabajo = value.join(',');
        }
    }

    public set otro_poblacion(value: string | null) {
        if (this.infoUser?.public_profile) {
            this.infoUser.public_profile.otro_poblacion ?? value;
        }
    }

    public set articulaciones_redes(value: string) {
        if (this.infoUser?.public_profile) {
            this.infoUser.public_profile.articulaciones_redes = value;
        }
    }

    public set tx_mision_vision(value: string) {
        if (this.infoUser) this.infoUser.mision_vision = value;
    }

    public set miembros_activos(value: string) {
        if (this.infoUser) this.infoUser.miembros_activos = value;
    }

    public set creation_date(value: string) {
        if (this.infoUser) this.infoUser.creation_date = value;
    }

    public set incluye_discapacidad(value: boolean) {
        if (this.infoUser) this.infoUser.incluye_discapacidad = value;
    }

    public set tipo_discapacidad(value: string) {
        if (this.infoUser) this.infoUser.tipo_discapacidad = value;
    }

    public set oferta_discapacidad(value: string) {
        if (this.infoUser) this.infoUser.oferta_discapacidad = value;
    }

    public set politicas_inclusion(value: string) {
        if (this.infoUser) this.infoUser.politicas_inclusion = value;
    }

    public set formato_actividades(value: string) {
        if (this.infoUser) this.infoUser.formato_actividades = value;
    }

    public set numero_integrantes(value: number) {
        if (this.infoUser) this.infoUser.numero_integrantes = value;
    }

    public set espacios_propios(value: boolean) {
        if (this.infoUser) this.infoUser.espacios_propios = value;
    }

    public set detalle_espacios(value: string) {
        if (this.infoUser) this.infoUser.detalle_espacios = value;
    }

    public set grupo_poblacional(value: string) {
        if (this.infoUser) this.infoUser.grupo_poblacional = value;
    }

    public set proyectos_desarrollados(value: string) {
        if (this.infoUser) this.infoUser.proyectos_desarrollados = value;
    }

    public set aliados(value: string) {
        if (this.infoUser) this.infoUser.aliados = value;
    }

    public set territorio_accion(value: string) {
        if (this.infoUser && this.infoUser.territory) {
            this.infoUser.territory.territorio_id = value;
        }
    }

    public set detalle_localidad(value: string) {
        if (this.infoUser && this.infoUser.territory) {
            this.infoUser.territory.detalle = value;
        }
    }

    public set mecanismos_participacion(value: string) {
        if (this.infoUser) this.infoUser.mecanismos_participacion = value;
    }

    public set recursos_publicos(value: boolean) {
        if (this.infoUser) this.infoUser.recursos_cultura = value;
    }

    public set tipo_apoyo_publico(value: string) {
        if (this.infoUser) this.infoUser.tipo_apoyo = value;
    }

    public set otro_tipo_apoyo(value: string) {
        if (this.infoUser) this.infoUser.otro_tipo_apoyo = value;
    }

    public set instrumentos_gestion(value: string) {
        if (this.infoUser) this.infoUser.insturmentos_apoyo = value;
    }

    public set estrategias_accesibilidad(value: string) {
        if (this.infoUser) this.infoUser.estrategias_accesibilidad = value;
    }

    public set ajustes_apoyos(value: string[]) {
        if (this.infoUser) {
            this.infoUser.ajustes_apoyos = value.join(',');
        }
    }

    public set interes_fortalecer(value: boolean) {
        if (this.infoUser) this.infoUser.interes_fortalecer = value;
    }

    constructor(public http: HttpClient) {
        super(http, 'profile');
    }

    getProfile = (id: number | string, ecosystem: string = 'artistas') =>
        this.getOne(id, ecosystem, `/${this.getEcosystemRoute(ecosystem)}/`).pipe(
            switchMap((x) => {
                this.infoUser = x.data;
                const data = {
                    user: this.vc_uuid_user,
                };
                this.dispatchData({ loadData: true });
                return this.getProfileFollowings(data, ecosystem);
            }),
            map((total_following) => {
                this.infoUser.total_following = total_following ?? 0;
                this.dispatchData({ loadDataFollowings: true });
                return this.infoUser;
            })
        );

    getProfileFollowings = (data: any, ecosystem: string = 'artistas') => this.addOne(data, ecosystem, `/${this.getEcosystemRoute(ecosystem)}/${data.user}/info${this.capitalize(this.getEcosystemRoute(ecosystem))}Siguiendo`).pipe(map((x) => x.data));

    getVideoIframe(url: string): string {
        let video, results;
        if (url === null || url === '') {
            return '';
        } else if (url.startsWith('https://www.youtube.com/watch?v=')) {
            results = url.match('[\\?&]v=([^&#]*)');
            video = results === null ? url : results[1];
            return 'https://www.youtube.com/embed/' + video;
        } else if (url.startsWith('https://vimeo.com/')) {
            results = url.split('/');
            video = results[results.length - 1];
            return 'https://player.vimeo.com/video/' + video;
        } else if (url.includes('behance.net/gallery/')) {
            // Behance → extraer el ID después de /gallery/
            results = url.split('/');
            let projectId = results[results.indexOf('gallery') + 1];
            return 'https://www.behance.net/embed/project/' + projectId + '?ilo0=1';
        } else if (url.includes('pinterest.com/pin/')) {
            // extraer el ID después de /pin/
            results = url.split('/');
            let pinId = results[results.indexOf('pin') + 1];
            return 'https://assets.pinterest.com/ext/embed.html?id=' + pinId;
        } else if (url.includes('open.spotify.com')) {
            if (url.includes('/embed/')) {
                return url;
            }
            url = url.replace(/\/intl-[a-zA-Z-]+/, '');

            return url.replace('https://open.spotify.com/', 'https://open.spotify.com/embed/');
        } else if (url.includes('spreaker.com/podcast/')) {
            // Spreaker Podcast → usar show_id
            results = url.split('--');
            let showId = results[results.length - 1];
            return 'https://widget.spreaker.com/player?show_id=' + showId + '&theme=light&autoplay=false';
        } else if (url.includes('soundcloud.com')) {
            // Si ya es un embed, no volver a transformarlo
            if (url.startsWith('https://w.soundcloud.com/player/')) {
                return url;
            }
            // Si es un link normal de SoundCloud, transformarlo
            return 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(url);
        } else {
            return url;
        }
    }

    getProfilePublic = (username: string, ecosistema: string, url: string): Observable<Profile> => {
        return this.http.get<{ data: Profile }>(this.urls[ecosistema] + `/${url}/${username}/username`).pipe(
            map((response) => {
                this.infoUser = response.data;
                return this.infoUser;
            })
        );
    };

    //Controla la limpieza de la localización

    private isInputTouched = false;

    setInputTouched(isTouched: boolean) {
        this.isInputTouched = isTouched;
    }

    getInputTouched(): boolean {
        return this.isInputTouched;
    }

    //Capitaliza la primera letra para las rutas de los ecosistemas
    private capitalize(str: string) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    //Obtiene el ecosistema del usuario logueado para evitar errores con el de local storage
    getCurrentEcosystem(): string {
        // Cargar información del usuario logueado
        const user = JSON.parse(localStorage.getItem('auth_user') || '{}');
        // Mapear definition a ecosistema
        if (user?.definition) {
            const def = user.definition.toLowerCase();
            switch (def) {
                case 'artista':
                    return 'artistas';
                case 'colectivo':
                    return 'collective';
                case 'empresa':
                    return 'empresas';
                case 'espacio':
                    return 'espacios';
                default:
                    break;
            }
            // agregar más si hay otros tipos
        }
        return 'artistas';
    }

    //Limpiar la data
    clearProfile(): void {
        this.infoUser = undefined!;
    }

    //Options de formato de actividades colectivos
    public actividadesColectivos: Array<ArtisanTrade> = [
        { id: 1, label: 'Talleres' },
        { id: 2, label: 'Presentaciones' },
        { id: 3, label: 'Campañas' },
        { id: 4, label: 'Investigación' },
        { id: 5, label: 'Otro' },
    ];

    //Options de status de hacedores
    public statusHacedores: Array<ArtisanTrade> = [
        { id: 1, label: 'Registrado' },
        { id: 2, label: 'Aprobado' },
        { id: 3, label: 'Rechazado' },
        { id: 4, label: 'Devuelto' },
    ];
}
